<template>
  <div class="web-bg">
    <div class="content">
      <webaboutme></webaboutme>
    </div>
  </div>
</template>

<script>
import webaboutme from './webaboutme.vue'

export default {
  name: 'maincontent',
  components: {
    webaboutme
  },
  mounted () {}
}
</script>

<style>
.web-bg {
  height: 100%;
  width: 100%;
  margin: 0;
  background-color: rgb(201, 243, 230);
}

.web-bg,
.content::before {
  background: url("/static/bg.jpg") 0 / cover fixed;
}

.content {
  position: relative;
  top: 40%;
  transform: translateY(-50%);
  margin: auto;

  width: 600px;
  height: 220px;

  background: hsla(0, 0%, 100%, 0.25) border-box;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 0 0 1px hsla(0, 0%, 100%, 0.3) inset,
    0 0.5em 1em rgba(0, 0, 0, 0.6);
  text-shadow: 0 1px 1px hsla(0, 0%, 100%, 0.3);
}

.content::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: -30px;
  z-index: -1;
  -webkit-filter: blur(10px);
  filter: blur(10px);
}
</style>



// WEBPACK FOOTER //
// src/components/main_content.vue